import { drawRotatedLabel } from './common';
import { TEXT_ANGLE, HIGHLIGHT_BORDER, MIN_WIDTH_FOR_LETTER } from './styles';


const X_DAMPING = 0.5;
const X_EPSILON = 0.5;

// const DEBUG_LABEL = 'T842';


export class MutationColumn {
  constructor(label) {
    this.text = label;
    this.items = []
    this.blocks = [];
    this.alpha = 1;
    this.alphaTarget = 1;
    this.x = -1;
    this.xTarget = -1;
    this.homeX = -1;
    this.w = 0;
    this.wTarget = 0;
    this.homeW = 0;
    this.border = 0;
    this.borderTarget = 0;
  }

  addItem(item) {
    this.items.push(item);
    this.gene = item.mutation.gene;
  }

  add(block) {
    let w = block.w;
    let x = block.x + block.w * 0.5;
    this.x = x;
    this.xTarget = x;
    this.homeX = x;
    this.w = w;
    this.wTarget = w;
    this.homeW = w;
    this.blocks.push(block);
  }

  setX(x, w=0) {
    this.x = x;
    this.xTarget = x;
    this.homeX = x;
    this.w = w;
    this.wTarget = w;
    this.homeW = w;
    this.items.forEach(item=>{item.x = x, item.w = w});
    // if (this.text === DEBUG_LABEL) {
    //   console.log('setX', this.text, this.x, this.w, this.border);
    // }
  }


  setAngle(angle) {
    this.angle = angle;
    this.cosA = Math.cos(angle);
    this.sinA = Math.sin(angle);
  }

  reviseText() {
    let first = this.items[0].mutation;
    this.text = this.items.length === 1 ? first.label : first.posLabel
  }

  deemphasize(deemphasized) {
    this.deemphasized = deemphasized;
  }

  adjustX(n) {
    this.xTarget = this.homeX + n;
  }

  goHome() {
    this.xTarget = this.homeX;
    this.wTarget = this.homeW;
    this.alphaTarget = 1;
    // if (this.text === DEBUG_LABEL) {
    //   console.log('goHome', this.text, this.x, this.w, this.border, this.homeX, this.homeW);
    // }

  }

  showBorder() {
    this.borderTarget = HIGHLIGHT_BORDER;
    this.wTarget = Math.max(this.homeW, MIN_WIDTH_FOR_LETTER + 2);
  }

  hideBorder() {
    this.borderTarget = 0;
    this.wTarget = this.homeW;
  }


  fade() {
    this.alphaTarget = 0.4;
  }

  update() {
    let updating = false;
    /* the order here matters: if the width changes
      we want the x position to update too
     */
    if (this.w !== this.wTarget) {
      this.w += (this.wTarget - this.w) * X_DAMPING;
      if (Math.abs(this.wTarget - this.w) < X_EPSILON) {
        this.w = this.wTarget;
      } else {
        updating = true;
      }
      this.blocks.forEach(b=>b.w = this.w);
    }
    if (this.x !== this.xTarget || updating) {
      this.x += (this.xTarget - this.x) * X_DAMPING;
      if (Math.abs(this.xTarget - this.x) < X_EPSILON) {
        this.x = this.xTarget;
      } else {
        updating = true;
      }
      this.blocks.forEach(b=>b.x = this.x - this.w * 0.5);
    }
    if (this.border !== this.borderTarget) {
      this.border += (this.borderTarget - this.border) * X_DAMPING;
      if (Math.abs(this.borderTarget - this.border) < X_EPSILON) {
        this.border = this.borderTarget;
      } else {
        updating = true;
      }
      this.blocks.forEach(b=>b.border = this.border);
    }
    if (this.alphaTarget !== this.alpha) {
      this.alpha += (this.alphaTarget - this.alpha) * 0.5;
      if (Math.abs(this.alphaTarget - this.alpha) > 0.01) {
        updating = true;
      }
    }
    // if (updating && this.text === DEBUG_LABEL) {
    //   console.log('   update', this.text, this.x, this.w, this.border, this.xTarget, this.wTarget);
    // }
    return updating;
  }

  draw(ctx, y) {
    if (ctx.globalAlpha !== this.alpha) {
      ctx.globalAlpha = this.alpha;
    }
    // if (this.text === DEBUG_LABEL) {
    //   console.log('     draw', this.text, this.x, this.w, ctx.textBaseline, this.blocks.map(b=>b.x).join(','));
    // }
    drawRotatedLabel(ctx, this.text, this.x, y, TEXT_ANGLE);
  }


}